
export default {
	$newFashion: true,
	getDataList: {},
	getAllBusDomainList: {}
};